var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zingchart',{ref:"jobFamilyMappingChart",attrs:{"data":_vm.jobFamilyMappingChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }